module.exports = __webpack_public_path__ + "site/img/12.76875603.jpg";